// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AppLauncherHost_active__2jgUw {\n  overflow: hidden;\n}\n\n/* The reusable port keeps its source z-index; Promo's fixed rail is 1040. */\n.AppLauncherHost_active__2jgUw > div[role='presentation'][data-theme] {\n  z-index: 1100;\n}\n", ""]);
// Exports
exports.locals = {
	"active": "AppLauncherHost_active__2jgUw"
};
module.exports = exports;
